<script setup lang="ts">
  import { testIds } from '@gat-ship/types'
  import { text } from '@gat-ship/stakeholders'
  import { type StakeholderType } from '@gat-ship/types'
  import { computed } from 'vue'
  import { useCreateStakeholder } from '../../../../composables/useCreateStakeholder'
  import { useStakeholderPermissions } from '@gat-ship/stakeholders'
  import { DropdownMenuItem } from '@gat-ship/vue-components'

  const { canCreate } = useStakeholderPermissions()
  const props = defineProps<{
    stakeholderType: StakeholderType
  }>()

  const { modals } = useCreateStakeholder()

  function onOkClick() {
    modals.showModalStakeholderCreate({
      stakeholderType: props.stakeholderType
    })
  }

  const testId = computed(() => {
    if (props.stakeholderType === 'other') {
      return testIds.stakeholders.actions.addOtherParty
    }
    if (props.stakeholderType === 'vendor') {
      return testIds.stakeholders.actions.addVendor
    }
    return testIds.stakeholders.actions.addClient
  })

  const btnText = computed(
    () =>
      text.views.list(props.stakeholderType).buttons.add as {
        label?: string
        icon?: unknown
      }
  )
</script>

<template>
  <DropdownMenuItem
    v-if="canCreate()"
    :data-testid="testId"
    @click="onOkClick()"
  >
    <component :is="btnText.icon" v-if="btnText.icon" class="size-4" />
    {{ btnText.label }}
  </DropdownMenuItem>
</template>
